import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

export interface SubscriptionTier {
  id: string;
  name: string;
}

export interface onSelectTierProps {
  workspaceId: string;
  tierId: string;
}

type Props = {
  workspaceId: string;
  currentTierId: string | undefined;
  onSelect: (props: onSelectTierProps) => void;
  tierList: SubscriptionTier[];
  closeMenu: () => void;
};

export const SubscriptionTierSelector = ({
  workspaceId,
  currentTierId,
  onSelect,
  tierList,
  closeMenu,
}: Props) => {
  const [selectedTierId, setSelectedTierId] = useState(currentTierId ?? '');

  const handleSelectItem = useCallback(
    (tierId: string) => {
      setSelectedTierId(tierId);
      onSelect({ workspaceId, tierId });
      closeMenu();
    },
    [closeMenu, workspaceId, onSelect]
  );

  return (
    <View>
      <RadioButton.Group
        onValueChange={handleSelectItem}
        value={selectedTierId}
      >
        {tierList.map(({ id, name }) => (
          <RadioButton.Item
            key={id}
            label={name}
            value={id}
            labelStyle={[styles.label, styles.checkItem]}
            style={styles.item}
          />
        ))}
      </RadioButton.Group>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  item: {
    paddingVertical: 0,
    paddingRight: 4,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
  },
  checkItem: { color: role.textPrimary },
}));
